import { render, staticRenderFns } from "./BmvDropdown.vue?vue&type=template&id=06dd226e&scoped=true"
import script from "./BmvDropdown.vue?vue&type=script&lang=js"
export * from "./BmvDropdown.vue?vue&type=script&lang=js"
import style0 from "./BmvDropdown.vue?vue&type=style&index=0&id=06dd226e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06dd226e",
  null
  
)

export default component.exports